// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__g3wcI","head":"ProcedureTableInfo_head__sJSZv"};